// extracted by mini-css-extract-plugin
var _1 = "EditorPlaceholder-module__actions--EhktG";
var _2 = "EditorPlaceholder-module__animateUploadProgressBarWidth--scKoY";
var _3 = "EditorPlaceholder-module__animatedBackground--w9muv";
var _4 = "EditorPlaceholder-module__button--r6arn";
var _5 = "EditorPlaceholder-module__container--p54sN";
var _6 = "EditorPlaceholder-module__content--gl7HR";
var _7 = "EditorPlaceholder-module__fileInput--_PHat";
var _8 = "EditorPlaceholder-module__fileInputLabel--YPb4K";
var _9 = "EditorPlaceholder-module__icon--tKl6r";
var _a = "EditorPlaceholder-module__note--RU4r4";
var _b = "EditorPlaceholder-module__template--UietB";
var _c = "EditorPlaceholder-module__templatesActions--wwyPL";
var _d = "EditorPlaceholder-module__templatesList--mUzTK";
var _e = "EditorPlaceholder-module__title--WLosK";
export { _1 as "actions", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "button", _5 as "container", _6 as "content", _7 as "fileInput", _8 as "fileInputLabel", _9 as "icon", _a as "note", _b as "template", _c as "templatesActions", _d as "templatesList", _e as "title" }
